import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { API_BASE } from './api'
import { exchangeVippsCode, clearVippsSession } from './vippsAuth'
import { LoginShell } from './Login'
import { Alert, Button } from './components/ui'
import './Login.css'

function VippsAuthCallback({ onLoginSuccess }) {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState('')
  const [checkingFacility, setCheckingFacility] = useState(false)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      const oauthError = searchParams.get('error')
      if (oauthError) {
        clearVippsSession()
        setError(`Vipps-feil: ${oauthError}`)
        return
      }
      const code = searchParams.get('code')
      const state = searchParams.get('state')
      if (!code) {
        setError('Mangler autorisasjonskode fra Vipps')
        return
      }
      try {
        const idToken = await exchangeVippsCode({ apiBase: API_BASE, code, state })
        if (cancelled) return

        setCheckingFacility(true)
        const headers = {
          Authorization: `Bearer ${idToken}`,
          'Content-Type': 'application/json',
        }
        const facRes = await fetch(`${API_BASE}/api/facilities/my`, { headers })
        if (facRes.ok) {
          const facilities = await facRes.json()
          if (!facilities || facilities.length === 0) {
            localStorage.removeItem('firebaseToken')
            setError('Du er ikke registrert som eier/admin av et anlegg. Kontakt Spelaren.')
            setCheckingFacility(false)
            return
          }
        }

        if (onLoginSuccess) onLoginSuccess(idToken)
        navigate('/', { replace: true })
      } catch (err) {
        if (!cancelled) {
          clearVippsSession()
          setError(err.message || 'Vipps-innlogging feilet')
        }
      } finally {
        if (!cancelled) setCheckingFacility(false)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [searchParams, navigate, onLoginSuccess])

  return (
    <LoginShell>
      {error ? (
        <div className="login-step">
          <div className="login-step-head">
            <h2 className="login-step-title">Vipps-innlogging</h2>
          </div>
          <Alert tone="error">{error}</Alert>
          <Button size="lg" onClick={() => navigate('/', { replace: true })}>
            Tilbake til innlogging
          </Button>
        </div>
      ) : (
        <div className="login-wait" role="status">
          <span className="spinner" aria-hidden="true" />
          <span className="login-wait-title">
            {checkingFacility ? 'Sjekker tilgang…' : 'Fullfører innlogging med Vipps…'}
          </span>
          {checkingFacility && (
            <span className="login-wait-text">Vi henter anleggene du er eier eller admin for.</span>
          )}
        </div>
      )}
    </LoginShell>
  )
}

export default VippsAuthCallback
